import { useQuery } from '@tanstack/react-query'

import type { Entity } from '@models/Entity'

import { useAuthenticatedUser } from '../../../auth/hooks/useAuthenticatedUser'
import { fetchSubprocesTemplatesForEntity } from '../services/fetchSubprocesTemplates'

const initialData = []

export const useSubprocesTemplatesForEntity = (entity: Entity) => {
  const { hasPermissions } = useAuthenticatedUser()

  const { data, isFetching: isLoading } = useQuery({
    queryKey: ['subprocesTemplatesForEntity', entity.id],
    queryFn: () => fetchSubprocesTemplatesForEntity(entity),
    enabled: hasPermissions && !!entity.id,
  })

  return {
    data: data || initialData,
    isLoading,
  }
}
